<script>
  export let id

  import { navigate, link } from 'svelte-navigator'
  import { fetchO, patchO, postO } from '../../oauth.js'
  import { dndzone } from 'svelte-dnd-action'

  import WorkoutPlanSetEditWidget from '../../components/WorkoutPlanSetEditWidget.svelte'
  import WorkoutPlanMetaEditForm from '../../components/WorkoutPlanMetaEditForm.svelte'
  import WorkoutPlanShareModal from '../../modals/WorkoutPlanShareModal.svelte'
  import Collapse from '../../../node_modules/bootstrap/js/dist/collapse'

  // Fetch workoutplan
  let workout_plan
  let exercises

  let disableExerciseReordering = false
  let disableSetReordering = false

  let dragDisabled = true

  function handleDndConsider(e) {
    workout_plan.sets = e.detail.items
  }

  async function handleDndFinalize(e) {
    workout_plan.sets = e.detail.items
    dragDisabled = true
    disableSetReordering = true

    console.log('Should save reordered sets', workout_plan.sets)
    const response = await patchO(workout_plan.url, {
      sets: workout_plan.sets.map((e) => e.url),
    })
    console.log('Response is', response)

    fetchWorkoutPlan()

    disableSetReordering = false
  }

  function startDrag(e) {
    // preventing default to prevent lag on touch devices (because of the browser checking for screen scrolling)
    e.preventDefault()
    dragDisabled = false
  }

  async function fetchWorkoutPlan() {
    const response = await fetchO('/workout_plans/' + id + '/details/')
    workout_plan = await response.json()
  }
  fetchWorkoutPlan()

  async function fetchExercises() {
    const response = await fetchO('/exercises/')
    exercises = await response.json()
  }
  fetchExercises()

  async function saveExercise(event) {
    console.log('Should save WP Exercise', event.detail)

    const response = await patchO(event.detail.url, {
      amount: event.detail.amount,
      execution_type: event.detail.execution_type,
      exercise: event.detail.exercise.url,
    })
    console.log('Response is', response)
  }

  async function saveNewExercise(event) {
    console.log('Should save new WP Exercise', event.detail)

    const response = await postO(event.detail.set.url + 'exercises/', {
      amount: event.detail.amount,
      execution_type: event.detail.execution_type,
      exercise: event.detail.exercise.url,
    })
    console.log('Response is', response)

    fetchWorkoutPlan()
  }

  async function addNewSet() {
    console.log('Should create a new WP Set')

    const response = await postO('/workout_plans/' + id + '/sets/', {})
    console.log('Response is', response)

    await fetchWorkoutPlan()

    // Scroll to bottom to show the added set
    window.scrollTo(0, document.body.scrollHeight)
  }

  async function deleteExercise(event) {
    console.log('Should delete exercise', event.detail)

    const response = await fetchO(event.detail.url, {
      method: 'DELETE',
    })
    console.log('Response is', response)

    fetchWorkoutPlan()
  }

  async function deleteSet(event) {
    console.log('Should delete set', event.detail)

    const response = await fetchO(event.detail.url, {
      method: 'DELETE',
    })
    console.log('Response is', response)

    fetchWorkoutPlan()
  }

  async function reorderExercises(event) {
    disableExerciseReordering = true
    console.log('Should reorder exercises', event.detail)

    const response = await patchO(event.detail.url, {
      exercises: event.detail.exercises.map((e) => e.url),
    })
    console.log('Response is', response)

    fetchWorkoutPlan()
    disableExerciseReordering = false
  }

  async function deletePlan() {
    console.log('Should Delete Plan')

    const response = await fetchO(workout_plan.url, {
      method: 'DELETE',
    })
    console.log('Response is', response)

    if (response.status == 204) {
      navigate('../')
    }
  }

  let metaSaving = false
  async function saveWorkoutPlan(event) {
    console.log('Should save for ' + workout_plan.url, event.detail)

    metaSaving = true
    const response = await patchO(workout_plan.url, event.detail)

    console.log('response', response)
    fetchWorkoutPlan()

    // HACK: Should be done through svelte
    new Collapse(document.getElementById('editMetadataForm')).hide()

    metaSaving = false

    // HACK: Should be done through svelte
    window.scrollTo(0, 0)
  }
</script>

{#if !exercises || !workout_plan}
  <div class="spinner-border" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
{:else}
  <WorkoutPlanShareModal {workout_plan} id="share_modal" />

  <div class="d-flex pb-1">
    <div class="me-auto">
      <h3>Editing Plan "{workout_plan.title}"</h3>
    </div>
    <div class="btn-group" role="group">
      <button class="btn btn-secondary" on:click={addNewSet}
        ><i class="bi bi-plus-square" />
        <span class="d-none d-lg-inline">Add Set</span></button
      >
      <a
        href="/workoutplans/train/{workout_plan.id}"
        use:link
        class="btn btn-primary"
        ><i class="bi bi-trophy" />
        <span class="d-none d-lg-inline">Train</span></a
      >
      <button
        class="btn btn-secondary"
        type="button"
        data-bs-toggle="collapse"
        data-bs-target="#editMetadataForm"
        aria-expanded="false"
        aria-controls="editMetadataForm"
        id="editMetadataFormButton"
        ><i class="bi bi-pencil" /><i class="bi bi-pencil-fill" />
        <span class="d-none d-lg-inline">Edit Meta</span></button
      >
      <button
        class="btn btn-secondary"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#share_modal"
      >
        <i class="bi bi-people" />
        <span class="d-none d-lg-inline">Share Plan</span>
      </button>
      <button class="btn btn-danger" on:click={deletePlan}
        ><i class="bi bi-trash" />
        <span class="d-none d-lg-inline">Delete Plan</span></button
      >
    </div>
  </div>

  <div class="pb-3 collapse" id="editMetadataForm">
    <div class="card" style="width: 100%;">
      <div class="card-header">Edit Plan</div>
      <div class="card-body">
        <WorkoutPlanMetaEditForm
          workoutPlan={workout_plan}
          submitLabel="Edit Plan"
          on:save={saveWorkoutPlan}
          saving={metaSaving}
        />
      </div>
    </div>
  </div>

  <div
    class="row g-3"
    use:dndzone={{
      items: workout_plan.sets,
      type: 'sets',
      dragDisabled: dragDisabled,
      dropTargetStyle: { outline: 'var(--bs-primary) solid 2px' },
    }}
    on:consider={handleDndConsider}
    on:finalize={handleDndFinalize}
  >
    {#each workout_plan.sets as set, seti (set.id)}
      <div class="col-lg-6">
        <WorkoutPlanSetEditWidget
          {set}
          {seti}
          {disableSetReordering}
          {disableExerciseReordering}
          exercises={exercises.results}
          reorderHandleMouseDown={startDrag}
          on:saveExercise={saveExercise}
          on:saveNewExercise={saveNewExercise}
          on:deleteExercise={deleteExercise}
          on:deleteSet={deleteSet}
          on:reorderExercises={reorderExercises}
        />
      </div>
    {/each}
  </div>
{/if}

<svelte:head>
  {#if workout_plan}
    <title>Editing Fich Workout Plan {workout_plan.title}</title>
  {/if}
</svelte:head>

<style>
  #editMetadataFormButton:global([aria-expanded='true']) .bi-pencil {
    display: none;
  }
  #editMetadataFormButton:global([aria-expanded='false']) .bi-pencil-fill {
    display: none;
  }
</style>
